import React, { Fragment } from 'react'
import Button from 'tfs.button'

import ClientPassengerToBeDeletedInterface from '../../interfaces/client/PassengerToBeDeleted'

import getLabels from '../../utils/getLabels'

import LoadingIcon from '../LoadingIcon'
import Modal from '../Modal'
import FlightPassengersDeleteOverview from '../FlightPassengersDeleteOverview'

import styles from './DeletePassengersOverview.module.scss'
import globalStyles from '../../styles/global.module.scss'

interface DeletePassengersOverviewPropsInterface {
  handleCancelDelete: Function
  handleConfirmDelete: Function

  isOpen: boolean
  isLoading: boolean
  deleteAllPaxFromSingleFlight: boolean

  flightId: string
  passengersToBeDeleted: ClientPassengerToBeDeletedInterface[]
  passengerIdsToBeDeleted: string[]
}

export default ({
  handleCancelDelete,
  handleConfirmDelete,
  isOpen,
  isLoading,
  flightId,
  passengersToBeDeleted,
  passengerIdsToBeDeleted,
  deleteAllPaxFromSingleFlight,
}: DeletePassengersOverviewPropsInterface) => {
  if (!isOpen) return null

  const isVisible = String(!isLoading)

  return (
    <Fragment>
      <Modal isOpen={isOpen}>
        {isLoading ? (
          <div className={styles['spinner-container']}>
            <LoadingIcon />
          </div>
        ) : (
          <FlightPassengersDeleteOverview
            items={passengersToBeDeleted}
            flightId={flightId}
            deleteAllPaxFromSingleFlight={
              deleteAllPaxFromSingleFlight
            }
          />
        )}
      </Modal>

      <div className={styles['controls']} data-visible={isVisible}>
        <div
          className={`${styles['controls-inner']} ${globalStyles['page-item']}`}
        >
          <Button
            type="button"
            color="white"
            onClick={handleCancelDelete}
            data-element="cancel-delete"
          >
            {getLabels('no_keep_passengers')}
          </Button>
          <Button
            type="button"
            color="red"
            data-element="confirm-delete"
            onClick={() =>
              handleConfirmDelete(passengerIdsToBeDeleted, flightId)
            }
          >
            {getLabels('yes_delete_passengers')}
          </Button>
        </div>
      </div>
    </Fragment>
  )
}
